export const GET_USER = '[User] Get User';
export const GET_USER_SUCCESS = '[User] Get User Success';
export const GET_USER_ERROR = '[User] Get User Error';

export const UPDATE_USER = '[User] Update User';
export const UPDATE_USER_SUCCESS = '[User] Update User Success';
export const UPDATE_USER_ERROR = '[User] Update User Error';

export const SEARCH_USERS = '[User] Search users';
export const SEARCH_USERS_SUCCESS = '[User] Search users Success';
export const SEARCH_USERS_ERROR = '[User] Search users Error';

export const DELETE_USER = '[User] Delete User';
export const DELETE_USER_SUCCESS = '[User] Delete User Success';
export const DELETE_USER_ERROR = '[User] Delete User Error';

export const RESET_USER_STORE = '[User] Reset store';

export const ADD_NEW_ACCOUNT = '[User] Add new account';
export const MARK_AS_VERIFIED = '[User] Mark as verified';

export const CREATE_ADDITIONAL_ACCOUNT = '[User] Create additional account';
export const CREATE_ADDITIONAL_ACCOUNT_SUCCESS =
  '[User] Create additional account Success';
export const CREATE_ADDITIONAL_ACCOUNT_ERROR =
  '[User] Create additional account Error';

export const DELETE_ADDITIONAL_ACCOUNT = '[User] Delete additional account';
export const DELETE_ADDITIONAL_ACCOUNT_SUCCESS =
  '[User] Delete additional account Success';
export const DELETE_ADDITIONAL_ACCOUNT_ERROR =
  '[User] Delete additional account Error';

export const CHECK_ADDITIONAL_EMAILS = '[User] Check additional emails';